import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import { ProcessTypeEnum } from '../../constants/enums';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import {
  IAddProcess,
  IUpdateProcess,
} from '../../models/forms/IAddUpdateProcess';
import {
  IMultiSelectOption,
  IOption,
  IReactSelectOption,
} from '../../models/ICommon';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import {
  IProcessList,
  IProcessListVM,
  IProcessVM,
} from '../../models/response/IProcessResponse';
import { IProcessState } from '../../models/state/IProcessState';
import { formatMessage } from '../../translations/format-message';
import {
  AddEditTagReassignState,
  GetAllProcessState,
  GetAllTagReassignState,
  GetProcessState,
  ObservableInitialState,
} from '../initialState';
import * as baseService from '../service/base-service';
import { IAddProcessDimensionData } from '../../models/forms/IAddProcessDimensionData';
import {
  IDimensionDataItems,
  IProcessDimensionData,
} from '../../models/response/IProcessDimensionData';
import { da } from 'date-fns/locale';
import { IDimensionListVM } from '../../models/response/IDimensionResponse';
import { ITagReassignState } from '../../models/state/ITagReassignState';
import {
  ITagReassignList,
  ITagReassignListVM,
  ITagReassignVM,
} from '../../models/response/ITagReassignResponse';
import { ITagTrayPayload } from '../../models/forms/IAssignedTag';
const appConfig = config();

interface IColumnProps {
  ShortName: string;
  IsHidden: boolean;
}

export class TagReassignStore implements ITagReassignState {
  initialStateValue = ObservableInitialState;
  processList: ITagReassignListVM = GetAllTagReassignState;
  process: ITagReassignVM | undefined = undefined;
  processState = { ...this.initialStateValue };
  addUpdateProcessState = { ...this.initialStateValue };
  deleteProcessState = { ...this.initialStateValue };
  getAllProcessState = { ...this.initialStateValue };
  checkedColumns: IColumnProps[] = [];
  saveDimensionDataState = { ...this.initialStateValue };
  getProcessDimensionDataState = { ...this.initialStateValue };
  processDimension: IProcessDimensionData | undefined = undefined;
  getDimensionByProcessIdState = { ...this.initialStateValue };
  dimensionByProcessIdList: IDimensionListVM | undefined = undefined;
  trayTagReassignState = {...this.initialStateValue};
  responseData: string = '';

  constructor() {
    makeObservable(this, {
      process: observable,
      processState: observable,
      processList: observable,
      addUpdateProcessState: observable,
      deleteProcessState: observable,
      getAllProcessState: observable,
      GetProcessListService: action,
      GetProcessByIdService: action,
      AddProcessService: action,
      UpdateProcessService: action,
      DeleteProcessService: action,
      GetAllProcessService: action,
      resetDeleteProcess: action,
      resetAddUpdateProcessState: action,
      reset: action,
      allProcess: computed,
      processDetails: computed,
      checkedColumns: observable,
      setCheckedColumns: action,
      saveDimensionDataState: observable,
      SaveDimensionDataService: action,
      resetSaveDimensionDataState: action,
      getProcessDimensionDataState: observable,
      GetProcessDimensionDataService: action,
      resetGetProcessDimensionDataState: action,
      processDimension: observable,
      getDimensionByProcessIdState: observable,
      dimensionByProcessIdList: observable,
      resetGetAllProcessState: action,
      TrayTagReassignService: action,
      trayTagReassignState: observable,
      resetTrayTagReassignState: action
      // processDimensionData: computed,
    });
  }

  //#region Actions
  //   GetProcessListService = (
  //     currentPage: number,
  //     pagerSize: number,
  //     filterQuery: string
  //   ) => {
  //     this.getAllProcessState.inProgress = true;
  //     const url =
  //       URLConstants.GetAllProcessList +
  //       '?PageSize=' +
  //       pagerSize +
  //       '&PageNo=' +
  //       currentPage +
  //       '&filterQuery=' +
  //       filterQuery;
  //     return baseService
  //       .getRequest(url)
  //       .then((response: IApiResponse<IApiSuccessResponse<ITagReassignListVM>>) => {
  //         if (response.data.Error) {
  //           this.getAllProcessState.error = response.data.Message;
  //           toast.error(formatMessage(response.data.Message));
  //         } else {
  //           this.processList = response.data.Data;
  //           this.getAllProcessState.success = true;
  //         }
  //       })
  //       .catch((err: string) => {
  //         this.getAllProcessState.error = err;
  //       })
  //       .finally(
  //         action(() => {
  //           this.getAllProcessState.inProgress = false;
  //         })
  //       );
  //   };

  TrayTagReassignService = (data: ITagTrayPayload) => {
    this.trayTagReassignState.inProgress = true;
    const url = URLConstants.TrayTagReassign;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<string>>) => {
        if (response.data.Error) {
          this.trayTagReassignState.error = response.data.Message;
          const responseData = response.data.Data;
          this.responseData = responseData;
        } else {
          this.trayTagReassignState.success = true;
        }
      })
      .catch((err: string) => {
        this.trayTagReassignState.error = err;
      })
      .finally(
        action(() => {
          this.trayTagReassignState.inProgress = false;
        })
      );
  };

  GetProcessListService = (
    tenantId: number,
    currentPage: number,
    pageLimit: number,
    TrayId: string
    // searchTerm: ICheckItemFilter
  ) => {
    this.getAllProcessState.inProgress = true;
    const url = URLConstants.GetAllTagReassignList;
    const data = {
      TenantId: tenantId,
      PageNumber: currentPage,
      PageSize: pageLimit,
      TrayId: TrayId
    };
    return baseService
      .postRequest(url, data)
      .then(
        (response: IApiResponse<IApiSuccessResponse<ITagReassignListVM>>) => {
          if (response.data.Error) {
            this.getAllProcessState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.processList = response.data.Data;
          }
        }
      )
      .catch((err: any) => {
        this.getAllProcessState.error = err;
      })
      .finally(
        action(() => {
          this.getAllProcessState.inProgress = false;
        })
      );
  };

  AddProcessService = (data: IAddProcess) => {
    this.addUpdateProcessState.inProgress = true;
    const url = URLConstants.AddProcess;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateProcessState.error = response.data.Message;
        } else {
          this.addUpdateProcessState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateProcessState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateProcessState.inProgress = false;
        })
      );
  };

  UpdateProcessService = (data: IUpdateProcess) => {
    this.addUpdateProcessState.inProgress = true;
    let url = URLConstants.UpdateProcess;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateProcessState.error = response.data.Message;
        } else {
          this.addUpdateProcessState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateProcessState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateProcessState.inProgress = false;
        })
      );
  };

  GetProcessByIdService = (id: number) => {
    this.processState.inProgress = true;
    let url = URLConstants.GetProcessById + '/' + id;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITagReassignVM>>) => {
        if (response.data.Error) {
          this.processState.error = response.data.Message;
        } else {
          this.process = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.processState.error = err;
      })
      .finally(
        action(() => {
          this.processState.inProgress = false;
        })
      );
  };

  DeleteProcessService = (id: number) => {
    this.deleteProcessState.inProgress = true;
    const url = URLConstants.DeleteProcess + '/' + id;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteProcessState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteProcessState.success = true;
      })
      .catch((err: string) => {
        this.deleteProcessState.error = err;
      })
      .finally(
        action(() => {
          this.deleteProcessState.inProgress = false;
        })
      );
  };

  GetAllProcessService = (
    tenentId?: number
    //  processOrder?: string
  ) => {
    // const ProcessOrder = processOrder === 'null' ? '' : processOrder;
    this.getAllProcessState.inProgress = true;
    let url = URLConstants.GetAllProcess;
    if (tenentId !== undefined) {
      url += `?tenantId=${tenentId}`;
    }
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<ITagReassignListVM>>) => {
          if (response.data.Error) {
            this.getAllProcessState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.processList = response.data.Data;
            this.processList.TagReassigns.forEach((item) => {
              // const exists = this.checkedColumns.some(
              //   (c) => c.ShortName === item.ShortName
              // );
              // if (!exists)
              //   this.checkedColumns.push({
              //     ShortName: item.ShortName,
              //     IsHidden: false,
              //   });
            });
          }
        }
      )
      .catch((err: string) => {
        this.getAllProcessState.error = err;
      })
      .finally(
        action(() => {
          this.getAllProcessState.inProgress = false;
        })
      );
  };

  SaveDimensionDataService = (data: IAddProcessDimensionData) => {
    this.saveDimensionDataState.inProgress = true;
    const url = URLConstants.SaveProcessDimensionData;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.saveDimensionDataState.error = response.data.Message;
        } else {
          toast.success(formatMessage(response.data.Message));
          this.saveDimensionDataState.success = true;
        }
      })
      .catch((err: string) => {
        this.saveDimensionDataState.error = err;
      })
      .finally(
        action(() => {
          this.saveDimensionDataState.inProgress = false;
        })
      );
  };

  GetProcessDimensionDataService = (ProcessId: number) => {
    this.getProcessDimensionDataState.inProgress = true;
    const url = URLConstants.GetProcessDimensionData + '/' + ProcessId;
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<IProcessDimensionData>>
        ) => {
          if (response.data.Error) {
            this.getProcessDimensionDataState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.processDimension = response.data.Data;
            this.getProcessDimensionDataState.success = true;
          }
        }
      )
      .catch((err: string) => {
        this.getProcessDimensionDataState.error = err;
      })
      .finally(
        action(() => {
          this.getProcessDimensionDataState.inProgress = false;
        })
      );
  };

  //#endregion

  //#region Computed
  setCheckedColumns = (data: IColumnProps[]) => {
    this.checkedColumns = [...data];
  };

  get allProcess(): ITagReassignList[] {
    let processData: ITagReassignList[] = [];
    if (
      this.processList?.TagReassigns &&
      this.processList.TagReassigns?.length > 0
    ) {
      this.processList.TagReassigns.map((process) => {
        processData.push({
          Id: process.Id,
          ProcessName: process.ProcessName,
          TrayId: process.TrayId,
          TagId: process.TagId,
        });
      });
    }
    return processData;
  }

  get processDetails(): ITagReassignVM {
    if (this.process) {
      return {
        Id: this.process.Id,
        ProcessName: this.process.ProcessName,
        TrayId: this.process.TrayId,
        TagId: this.process.TagId,
      };
    }
    return {
      Id: -1,
      ...AddEditTagReassignState,
    };
  }
  //#endregion

  //#region Reset
  reset = () => {
    this.processList = GetAllTagReassignState;
  };

  resetGetAllProcessState = () => {
    this.getAllProcessState = {...this.initialStateValue}
  }

  resetProcessDetail = () => {
    this.process = undefined;
    this.processState = { ...this.initialStateValue };
  };

  resetDeleteProcess = () => {
    this.deleteProcessState = { ...this.initialStateValue };
  };

  resetAddUpdateProcessState = () => {
    this.addUpdateProcessState.inProgress = false;
    this.addUpdateProcessState.success = false;
    this.addUpdateProcessState.error = '';
  };

  resetSaveDimensionDataState = () => {
    this.saveDimensionDataState = { ...this.initialStateValue };
  };

  resetGetProcessDimensionDataState = () => {
    this.getProcessDimensionDataState = { ...this.initialStateValue };
  };

  resetTrayTagReassignState = () => {
    this.trayTagReassignState = {...this.initialStateValue};
  }
  //#endregion
}

export default new TagReassignStore();
